// 2024 Topps Star Wars Hyperspace (released February 19, 2025)
// First Hyperspace release: five planets — Naboo, Kashyyyk, Hoth, Bespin, Mustafar.
// Cards transcribed from the official Topps checklist PDF; parallels and print
// runs source-verified against Trader Cracks, Checklist Center and Cardsmiths
// Breaks (all three agree on the ladders below; Galactic Origins Hyperlanes is
// /10 per Trader Cracks + Checklist Center — Cardsmiths' /25 is a source error).
// Base #86 is "Maximilian Veers" (one L) per the BPV checklist line, Cardsmiths
// and canon; the base line's "Maximillian" is a sell-sheet typo.
// Sketch Cards are intentionally omitted: 1/1 original art with an artist-only
// roster (105 artists), no card-level checklist in any source.

// Base parallel ladder. 2024 has BOTH Aqua /199 and Aqua Sonar /199 (unlike
// 2025, which dropped plain Aqua). Refractor and Nebulae are unnumbered.
const BASE_PARALLELS = [
  { id: 'refractor', name: 'Refractor', print_run: null, color: '#c8d8f0' },
  { id: 'nebulae', name: 'Nebulae Refractor', print_run: null, color: '#c9b6ff' },
  { id: 'aqua', name: 'Aqua Refractor', print_run: 199, color: '#4dd0e1' },
  { id: 'aqua-sonar', name: 'Aqua Sonar Refractor', print_run: 199, color: '#00e5ff' },
  { id: 'pulsar', name: 'Pulsar Refractor', print_run: 99, color: '#29b6f6' },
  { id: 'galactic-dust', name: 'Galactic Dust Refractor', print_run: 75, color: '#d4a855' },
  { id: 'gold-galactic-dust', name: 'Gold Galactic Dust Refractor', print_run: 50, color: '#f0c040' },
  { id: 'hyperlanes', name: 'Hyperlanes Refractor', print_run: 25, color: '#ff9100' },
  { id: 'black-hyperlanes', name: 'Black Hyperlanes Refractor', print_run: 10, color: '#b0b0b0' },
  { id: 'red-hyperlanes', name: 'Red Hyperlanes Refractor', print_run: 5, color: '#ff1744' },
  { id: 'superfractor', name: 'Superfractor', print_run: 1, color: '#f0c040' },
];

// Base Planetary Variations are serial /99 SPs with no further parallels.
// Single unnamed slot -> the UI renders just "/99".
const PLANETARY_VARIATION_PARALLELS = [
  { id: 'sp', name: '', print_run: 99, color: '#c8d8f0' },
];

// Shared 5-step insert ladder (There's Always a Bigger Fish, First Arrival,
// Galactic Eras).
const INSERT_5 = [
  { id: 'pulsar', name: 'Pulsar Refractor', print_run: 99, color: '#29b6f6' },
  { id: 'gold-galactic-dust', name: 'Gold Galactic Dust Refractor', print_run: 50, color: '#f0c040' },
  { id: 'hyperlanes', name: 'Hyperlanes Refractor', print_run: 25, color: '#ff9100' },
  { id: 'red-hyperlanes', name: 'Red Hyperlanes Refractor', print_run: 5, color: '#ff1744' },
  { id: 'superfractor', name: 'Superfractor', print_run: 1, color: '#f0c040' },
];

// Jump to Hyperspace (1 per case) skips the Hyperlanes /25 step.
const JUMP_PARALLELS = [
  { id: 'pulsar', name: 'Pulsar Refractor', print_run: 99, color: '#29b6f6' },
  { id: 'gold-galactic-dust', name: 'Gold Galactic Dust Refractor', print_run: 50, color: '#f0c040' },
  { id: 'red-hyperlanes', name: 'Red Hyperlanes Refractor', print_run: 5, color: '#ff1744' },
  { id: 'superfractor', name: 'Superfractor', print_run: 1, color: '#f0c040' },
];

const REFLECTIONS_PARALLELS = [
  { id: 'red-hyperlanes', name: 'Red Hyperlanes Refractor', print_run: 5, color: '#ff1744' },
  { id: 'superfractor', name: 'Superfractor', print_run: 1, color: '#f0c040' },
];

// Planetary Views base cards are themselves serial /99 (unnamed slot), with a
// short Gold Galactic Dust / Nebulae /5 / Superfractor ladder above.
const PLANETARY_VIEWS_PARALLELS = [
  { id: 'sp', name: '', print_run: 99, color: '#c8d8f0' },
  { id: 'gold-galactic-dust', name: 'Gold Galactic Dust Refractor', print_run: 50, color: '#f0c040' },
  { id: 'nebulae', name: 'Nebulae Refractor', print_run: 5, color: '#c9b6ff' },
  { id: 'superfractor', name: 'Superfractor', print_run: 1, color: '#f0c040' },
];

// Galactic Origins: Hyperlanes here is /10 (not the base ladder's /25).
const GALACTIC_ORIGINS_PARALLELS = [
  { id: 'hyperlanes', name: 'Hyperlanes Refractor', print_run: 10, color: '#ff9100' },
  { id: 'red-hyperlanes', name: 'Red Hyperlanes Refractor', print_run: 5, color: '#ff1744' },
  { id: 'superfractor', name: 'Superfractor', print_run: 1, color: '#f0c040' },
];

// Autograph parallels. Base autograph is an unnumbered on-card refractor
// (2 per 12-box case), so no serial slot needed.
const AUTO_PARALLELS_LADDER = [
  { id: 'pulsar', name: 'Pulsar Refractor', print_run: 99, color: '#29b6f6' },
  { id: 'gold-galactic-dust', name: 'Gold Galactic Dust Refractor', print_run: 50, color: '#f0c040' },
  { id: 'hyperlanes', name: 'Hyperlanes Refractor', print_run: 25, color: '#ff9100' },
  { id: 'red-hyperlanes', name: 'Red Hyperlanes Refractor', print_run: 5, color: '#ff1744' },
  { id: 'superfractor', name: 'Superfractor', print_run: 1, color: '#f0c040' },
];

export const SETS = [
  {
    id: 'base', type: 'base', title: 'BASE CARDS — 100 CARDS', parallels: BASE_PARALLELS,
    cards: [
      {n:'1', name:'Padmé Amidala'},
      {n:'2', name:'Chief Tarfful'},
      {n:'3', name:'Opee Sea Killer'},
      {n:'4', name:'HMP Droid Gunship'},
      {n:'5', name:'Republic Attack Gunship'},
      {n:'6', name:'Eirtaé'},
      {n:'7', name:'Cloud Car'},
      {n:'8', name:'Mylaya'},
      {n:'9', name:'Rep Teers'},
      {n:'10', name:'Captain Panaka'},
      {n:'11', name:'Theta-Class T-2c Shuttle'},
      {n:'12', name:'ISP Speeder'},
      {n:'13', name:'Queen Apailana'},
      {n:'14', name:'Gungi'},
      {n:'15', name:'Wampa'},
      {n:'16', name:'General Tarpals'},
      {n:'17', name:'Naboo Royal Guard'},
      {n:'18', name:'Northern Mustafarian'},
      {n:'19', name:'Wookiee Catamaran'},
      {n:'20', name:'Jar Jar Binks'},
      {n:'21', name:'Corporate Alliance Tank Droid'},
      {n:'22', name:'R2-D2'},
      {n:'23', name:'Droideka'},
      {n:'24', name:'Captain Typho'},
      {n:'25', name:'Krrsantan'},
      {n:'26', name:'X-Wings'},
      {n:'27', name:'Dormé'},
      {n:'28', name:'K-3PO'},
      {n:'29', name:'STAP'},
      {n:'30', name:'Queen Jamillia'},
      {n:'31', name:'Snowspeeder'},
      {n:'32', name:'Trade Federation Battleship'},
      {n:'33', name:'Wookiee Gunship'},
      {n:'34', name:'Boss Nass'},
      {n:'35', name:'Hoth Rebel Trooper'},
      {n:'36', name:'Droid Starfighters'},
      {n:'37', name:'Kybuck'},
      {n:'38', name:'Southern Mustafarian'},
      {n:'39', name:'Can-Cell'},
      {n:'40', name:'Sio Bibble'},
      {n:'41', name:'Kaadu'},
      {n:'42', name:'Millennium Falcon'},
      {n:'43', name:'Alazmec'},
      {n:'44', name:'Naboo star skiff'},
      {n:'45', name:'Lobot'},
      {n:'46', name:'Republic Frigate'},
      {n:'47', name:'Mustafar Panning Droid'},
      {n:'48', name:'Multi-Troop Transport'},
      {n:'49', name:'Rish Loo'},
      {n:'50', name:'Darth Vader'},
      {n:'51', name:'Boss Lyonie'},
      {n:'52', name:'Falumpaset'},
      {n:'53', name:'Tauntauns'},
      {n:'54', name:'Security S-5 blaster'},
      {n:'55', name:'Battle Droid'},
      {n:'56', name:'Ugnaught'},
      {n:'57', name:'Obi-Wan Kenobi'},
      {n:'58', name:'Gungan Bongo Submarine'},
      {n:'59', name:'Han Solo'},
      {n:'60', name:'AT-AT'},
      {n:'61', name:'Roggwart'},
      {n:'62', name:'Wookiee Long-Gun'},
      {n:'63', name:'Kylo Ren'},
      {n:'64', name:'2-1B'},
      {n:'65', name:'Trandoshan'},
      {n:'66', name:'Gondola Speeder'},
      {n:'67', name:'Sando Aqua Monster'},
      {n:'68', name:"Boba Fett's Starship"},
      {n:'69', name:'Helder Spinoza'},
      {n:'70', name:'Senator Palpatine'},
      {n:'71', name:'Nute Gunray'},
      {n:'72', name:'Imperial Probe Droid'},
      {n:'73', name:'Fambaas'},
      {n:'74', name:'C-3PO'},
      {n:'75', name:'Lando Calrissian'},
      {n:'76', name:'AT-AT Driver'},
      {n:'77', name:'Nuna'},
      {n:'78', name:'Naboo Starfighter'},
      {n:'79', name:'Mustafar Lava Flea'},
      {n:'80', name:'Ric Olié'},
      {n:'81', name:'Booma'},
      {n:'82', name:'Jedi Interceptor'},
      {n:'83', name:'Luke Skywalker'},
      {n:'84', name:'Naboo Royal Starship'},
      {n:'85', name:'San Hill'},
      {n:'86', name:'Maximilian Veers'},
      {n:'87', name:'Colo Claw Fish'},
      {n:'88', name:'Anti-Infantry Turret'},
      {n:'89', name:'Pedar Solardo'},
      {n:'90', name:'Sabé'},
      {n:'91', name:'Leia Organa'},
      {n:'92', name:'C-9979 Landing Ships'},
      {n:'93', name:'Planetary Ion Cannon'},
      {n:'94', name:'Wedge Antilles'},
      {n:'95', name:'Chewbacca'},
      {n:'96', name:'AAT Battle Tank'},
      {n:'97', name:'Boba Fett'},
      {n:'98', name:'Rune Haako'},
      {n:'99', name:'Yoda'},
      {n:'100', name:'Darth Sidious'},
    ]
  },
  {
    id: 'base-planetary-variations', type: 'base', title: 'BASE CARDS PLANETARY VARIATIONS — 100 CARDS', parallels: PLANETARY_VARIATION_PARALLELS,
    cards: [
      {n:'BPV-1', name:'Padmé Amidala'},
      {n:'BPV-2', name:'Chief Tarfful'},
      {n:'BPV-3', name:'Opee Sea Killer'},
      {n:'BPV-4', name:'HMP Droid Gunship'},
      {n:'BPV-5', name:'Republic Attack Gunship'},
      {n:'BPV-6', name:'Eirtaé'},
      {n:'BPV-7', name:'Cloud Car'},
      {n:'BPV-8', name:'Mylaya'},
      {n:'BPV-9', name:'Rep Teers'},
      {n:'BPV-10', name:'Captain Panaka'},
      {n:'BPV-11', name:'Theta-Class T-2c Shuttle'},
      {n:'BPV-12', name:'ISP Speeder'},
      {n:'BPV-13', name:'Queen Apailana'},
      {n:'BPV-14', name:'Gungi'},
      {n:'BPV-15', name:'Wampa'},
      {n:'BPV-16', name:'General Tarpals'},
      {n:'BPV-17', name:'Naboo Royal Guard'},
      {n:'BPV-18', name:'Northern Mustafarian'},
      {n:'BPV-19', name:'Wookiee Catamaran'},
      {n:'BPV-20', name:'Jar Jar Binks'},
      {n:'BPV-21', name:'Corporate Alliance Tank Droid'},
      {n:'BPV-22', name:'R2-D2'},
      {n:'BPV-23', name:'Droideka'},
      {n:'BPV-24', name:'Captain Typho'},
      {n:'BPV-25', name:'Krrsantan'},
      {n:'BPV-26', name:'X-Wings'},
      {n:'BPV-27', name:'Dormé'},
      {n:'BPV-28', name:'K-3PO'},
      {n:'BPV-29', name:'STAP'},
      {n:'BPV-30', name:'Queen Jamillia'},
      {n:'BPV-31', name:'Snowspeeder'},
      {n:'BPV-32', name:'Trade Federation Battleship'},
      {n:'BPV-33', name:'Wookiee Gunship'},
      {n:'BPV-34', name:'Boss Nass'},
      {n:'BPV-35', name:'Hoth Rebel Trooper'},
      {n:'BPV-36', name:'Droid Starfighters'},
      {n:'BPV-37', name:'Kybuck'},
      {n:'BPV-38', name:'Southern Mustafarian'},
      {n:'BPV-39', name:'Can-Cell'},
      {n:'BPV-40', name:'Sio Bibble'},
      {n:'BPV-41', name:'Kaadu'},
      {n:'BPV-42', name:'Millennium Falcon'},
      {n:'BPV-43', name:'Alazmec'},
      {n:'BPV-44', name:'Naboo star skiff'},
      {n:'BPV-45', name:'Lobot'},
      {n:'BPV-46', name:'Republic Frigate'},
      {n:'BPV-47', name:'Mustafar Panning Droid'},
      {n:'BPV-48', name:'Multi-Troop Transport'},
      {n:'BPV-49', name:'Rish Loo'},
      {n:'BPV-50', name:'Darth Vader'},
      {n:'BPV-51', name:'Boss Lyonie'},
      {n:'BPV-52', name:'Falumpaset'},
      {n:'BPV-53', name:'Tauntauns'},
      {n:'BPV-54', name:'Security S-5 blaster'},
      {n:'BPV-55', name:'Battle Droid'},
      {n:'BPV-56', name:'Ugnaught'},
      {n:'BPV-57', name:'Obi-Wan Kenobi'},
      {n:'BPV-58', name:'Gungan Bongo Submarine'},
      {n:'BPV-59', name:'Han Solo'},
      {n:'BPV-60', name:'AT-AT'},
      {n:'BPV-61', name:'Roggwart'},
      {n:'BPV-62', name:'Wookiee Long-Gun'},
      {n:'BPV-63', name:'Kylo Ren'},
      {n:'BPV-64', name:'2-1B'},
      {n:'BPV-65', name:'Trandoshan'},
      {n:'BPV-66', name:'Gondola Speeder'},
      {n:'BPV-67', name:'Sando Aqua Monster'},
      {n:'BPV-68', name:"Boba Fett's Starship"},
      {n:'BPV-69', name:'Helder Spinoza'},
      {n:'BPV-70', name:'Senator Palpatine'},
      {n:'BPV-71', name:'Nute Gunray'},
      {n:'BPV-72', name:'Imperial Probe Droid'},
      {n:'BPV-73', name:'Fambaas'},
      {n:'BPV-74', name:'C-3PO'},
      {n:'BPV-75', name:'Lando Calrissian'},
      {n:'BPV-76', name:'AT-AT Driver'},
      {n:'BPV-77', name:'Nuna'},
      {n:'BPV-78', name:'Naboo Starfighter'},
      {n:'BPV-79', name:'Mustafar Lava Flea'},
      {n:'BPV-80', name:'Ric Olié'},
      {n:'BPV-81', name:'Booma'},
      {n:'BPV-82', name:'Jedi Interceptor'},
      {n:'BPV-83', name:'Luke Skywalker'},
      {n:'BPV-84', name:'Naboo Royal Starship'},
      {n:'BPV-85', name:'San Hill'},
      {n:'BPV-86', name:'Maximilian Veers'},
      {n:'BPV-87', name:'Colo Claw Fish'},
      {n:'BPV-88', name:'Anti-Infantry Turret'},
      {n:'BPV-89', name:'Pedar Solardo'},
      {n:'BPV-90', name:'Sabé'},
      {n:'BPV-91', name:'Leia Organa'},
      {n:'BPV-92', name:'C-9979 Landing Ships'},
      {n:'BPV-93', name:'Planetary Ion Cannon'},
      {n:'BPV-94', name:'Wedge Antilles'},
      {n:'BPV-95', name:'Chewbacca'},
      {n:'BPV-96', name:'AAT Battle Tank'},
      {n:'BPV-97', name:'Boba Fett'},
      {n:'BPV-98', name:'Rune Haako'},
      {n:'BPV-99', name:'Yoda'},
      {n:'BPV-100', name:'Darth Sidious'},
    ]
  },
  {
    id: 'jump-to-hyperspace', type: 'insert', title: 'JUMP TO HYPERSPACE — 5 CARDS', parallels: JUMP_PARALLELS,
    cards: [
      {n:'JH-1', name:'Millennium Falcon'},
      {n:'JH-2', name:'Naboo Starfighter'},
      {n:'JH-3', name:'Republic Frigate'},
      {n:'JH-4', name:"Boba Fett's Starship"},
      {n:'JH-5', name:'The Ghost'},
    ]
  },
  {
    id: 'theres-always-a-bigger-fish', type: 'insert', title: "THERE'S ALWAYS A BIGGER FISH — 15 CARDS", parallels: INSERT_5,
    cards: [
      {n:'BF-1', name:'Tauntauns'},
      {n:'BF-2', name:'Wampa'},
      {n:'BF-3', name:'Fambaa'},
      {n:'BF-4', name:'Falumpaset'},
      {n:'BF-5', name:'Mylaya'},
      {n:'BF-6', name:'Roggwart'},
      {n:'BF-7', name:'Mustafar Lava Flea'},
      {n:'BF-8', name:'Shaak'},
      {n:'BF-9', name:'Opee Sea Killer'},
      {n:'BF-10', name:'Sando Aqua Monster'},
      {n:'BF-11', name:'Kaadu'},
      {n:'BF-12', name:'Nuna'},
      {n:'BF-13', name:'Colo Claw Fish'},
      {n:'BF-14', name:'Can-Cell'},
      {n:'BF-15', name:'Kybuck'},
    ]
  },
  {
    id: 'first-arrival', type: 'insert', title: 'FIRST ARRIVAL — 15 CARDS', parallels: INSERT_5,
    cards: [
      {n:'FA-1', name:'Padmé Amidala'},
      {n:'FA-2', name:'Chief Tarfful'},
      {n:'FA-3', name:'Sabé'},
      {n:'FA-4', name:'Lobot'},
      {n:'FA-5', name:'Boss Nass'},
      {n:'FA-6', name:'Captain Panaka'},
      {n:'FA-7', name:'Senator Palpatine'},
      {n:'FA-8', name:'Sio Bibble'},
      {n:'FA-9', name:'Ric Olié'},
      {n:'FA-10', name:'Chewbacca'},
      {n:'FA-11', name:'Boss Lyonie'},
      {n:'FA-12', name:'Jar Jar Binks'},
      {n:'FA-13', name:'Queen Jamillia'},
      {n:'FA-14', name:'General Tarpals'},
      {n:'FA-15', name:'Darth Vader'},
    ]
  },
  {
    id: 'galactic-eras', type: 'insert', title: 'GALACTIC ERAS — 25 CARDS', parallels: INSERT_5,
    cards: [
      {n:'GE-1', name:'Battle of Hoth'},
      {n:'GE-2', name:'Battle of Kachirho'},
      {n:'GE-3', name:'Battle of Naboo'},
      {n:'GE-4', name:'Obi-Wan Kenobi vs Anakin Skywalker'},
      {n:'GE-5', name:'Qui-Gon Jinn and Obi-Wan Kenobi vs Darth Maul'},
      {n:'GE-6', name:'Yoda, Chief Tarfful, and Chewbacca meet with Jedi Council'},
      {n:'GE-7', name:'Padmé Amidala and Anakin Skywalker'},
      // "attacks SEPARATIST" is verbatim from the official checklist (Trader
      // Cracks and Checklist Center reproduce the same casing).
      {n:'GE-8', name:'Anakin Skywalker attacks SEPARATIST'},
      {n:'GE-9', name:'Anakin Skywalker becomes Darth Vader'},
      {n:'GE-10', name:'Han Solo, Chewbacca, and Princess Leia Organa seek refuge'},
      {n:'GE-11', name:'Wedge Antilles trips up an AT-AT'},
      {n:'GE-12', name:'Luke Skywalker plants an explosive in an AT-AT'},
      {n:'GE-13', name:'Lando Calrissian double crosses Han Solo'},
      {n:'GE-14', name:'Duel on Cloud City'},
      {n:'GE-15', name:'Leia, Chewbacca, and Lando Calrissian escaping Bespin'},
      {n:'GE-16', name:'Qui-Gon Jinn and Obi-Wan Kenobi Meet Jar Jar Binks'},
      {n:'GE-17', name:'Qui-Gon Jinn and Obi-Wan Kenobi meet with the Gungan Rep Council'},
      {n:'GE-18', name:'Naboo Celebration'},
      {n:'GE-19', name:'Anakin Skywalker and Padmé Amidala Kiss'},
      {n:'GE-20', name:"Anakin Skywalker and Padmé Amidala's Secret Wedding"},
      {n:'GE-21', name:'Yoda departs Kashyyyk'},
      {n:'GE-22', name:'Kylo Ren finds Sith Wayfinder'},
      {n:'GE-23', name:'Boba Fett captures Han Solo'},
      {n:'GE-24', name:'Nute Gunray and Rune Haako captured'},
      {n:'GE-25', name:'Han Solo rescues Luke Skywalker'},
    ]
  },
  {
    id: 'star-wars-reflections', type: 'insert', title: 'STAR WARS REFLECTIONS — 5 CARDS', parallels: REFLECTIONS_PARALLELS,
    cards: [
      {n:'R-6', name:'Lord Vader'},
      {n:'R-7', name:"Ahsoka's Remorse"},
      {n:'R-8', name:'Dangerous Negotiations'},
      {n:'R-9', name:'No Love for the Empire'},
      {n:'R-10', name:'AT-AT Driver'},
    ]
  },
  {
    id: 'planetary-views', type: 'insert', title: 'PLANETARY VIEWS — 5 CARDS', parallels: PLANETARY_VIEWS_PARALLELS,
    cards: [
      {n:'PV-1', name:'Naboo'},
      {n:'PV-2', name:'Kashyyyk'},
      {n:'PV-3', name:'Mustafar'},
      {n:'PV-4', name:'Bespin'},
      {n:'PV-5', name:'Hoth'},
    ]
  },
  {
    id: 'galactic-origins', type: 'insert', title: 'GALACTIC ORIGINS — 10 CARDS', parallels: GALACTIC_ORIGINS_PARALLELS,
    cards: [
      {n:'GO-1', name:'Padmé Amidala'},
      {n:'GO-2', name:'Jar Jar Binks'},
      {n:'GO-3', name:'Chewbacca'},
      {n:'GO-4', name:'Chief Tarfful'},
      {n:'GO-5', name:'Senator Palpatine'},
      {n:'GO-6', name:'Darth Vader'},
      {n:'GO-7', name:'Lando Calrissian'},
      {n:'GO-8', name:'Lobot'},
      {n:'GO-9', name:'K-3PO'},
      {n:'GO-10', name:'Captain Panaka'},
    ]
  },
  {
    id: 'star-wars-autograph-variation', type: 'auto', title: 'STAR WARS AUTOGRAPH VARIATION — 46 CARDS', parallels: AUTO_PARALLELS_LADDER,
    cards: [
      {n:'A-AA', name:'Adria Arjona', artist:'Bix Caleen'},
      {n:'A-AD', name:'Adam Driver', artist:'Kylo Ren'},
      {n:'A-AS', name:'Andy Serkis', artist:'Kino Loy'},
      {n:'A-BD', name:'Benicio del Toro', artist:'DJ'},
      {n:'A-BL', name:'Billie Lourd', artist:'Lieutenant Connix'},
      {n:'A-BM', name:'Ben Mendelsohn', artist:'Orson Krennic'},
      {n:'A-BW', name:'Billy Dee Williams', artist:'Lando Calrissian'},
      {n:'A-DE', name:'Denise Gough', artist:'Dedra Meero'},
      {n:'A-DL', name:'Diego Luna', artist:'Cassian Andor'},
      {n:'A-DR', name:'Daisy Ridley', artist:'Rey'},
      {n:'A-EC', name:'Emilia Clarke', artist:"Qi'ra"},
      {n:'A-EM', name:'Ewan McGregor', artist:'Obi-Wan Kenobi'},
      {n:'A-FJ', name:'Felicity Jones', artist:'Jyn Erso'},
      {n:'A-FS', name:'Fiona Shaw', artist:'Maarva Andor'},
      {n:'A-FW', name:'Forest Whitaker', artist:'Saw Gerrera'},
      {n:'A-GL', name:'Domhnall Gleeson', artist:'General Hux'},
      {n:'A-GO', name:"Genevieve O'Reilly", artist:'Mon Mothma'},
      {n:'A-HC', name:'Hayden Christensen', artist:'Darth Vader'},
      {n:'A-HF', name:'Harrison Ford', artist:'Han Solo'},
      {n:'A-IM', name:'Ian McDiarmid', artist:'Darth Sidious'},
      {n:'A-IS', name:'Ivanna Sakhno', artist:'Shin Hati'},
      {n:'A-JB', name:'Jennifer Beals', artist:'Garsa Fwip'},
      {n:'A-JE', name:'Joel Edgerton', artist:'Owen Lars'},
      {n:'A-JL', name:'John Leguizamo', artist:'Gor Koresh'},
      {n:'A-KK', name:'Keira Knightley', artist:'Sabé'},
      {n:'A-KR', name:'Keri Russell', artist:'Zorii Bliss'},
      {n:'A-KS', name:'Katee Sackhoff', artist:'Bo-Katan Kryze'},
      {n:'A-LM', name:'Lars Mikkelsen', artist:'Grand Admiral Thrawn'},
      {n:'A-MH', name:'Mark Hamill', artist:'Luke Skywalker'},
      {n:'A-MM', name:'Mads Mikkelsen', artist:'Galen Erso'},
      {n:'A-MN', name:'Ming-Na Wen', artist:'Fennec Shand'},
      {n:'A-MW', name:'Mary Elizabeth Winstead', artist:'Hera Syndulla'},
      {n:'A-NN', name:'Nick Nolte', artist:'Kuiil'},
      {n:'A-NP', name:'Natalie Portman', artist:'Queen Amidala'},
      {n:'A-NY', name:"Lupita Nyong'o", artist:'Maz Kanata'},
      {n:'A-OI', name:'Oscar Isaac', artist:'Poe Dameron'},
      {n:'A-PP', name:'Pedro Pascal', artist:'The Mandalorian'},
      {n:'A-RA', name:'Riz Ahmed', artist:'Bodhi Rook'},
      {n:'A-RP', name:'Ray Park', artist:'Darth Maul'},
      {n:'A-SJ', name:'Samuel L. Jackson', artist:'Mace Windu'},
      {n:'A-SO', name:'Kyle Soller', artist:'Syril Karn'},
      {n:'A-SS', name:'Stellan Skarsgård', artist:'Luthen Rael'},
      {n:'A-TM', name:'Temuera Morrison', artist:'Boba Fett'},
      {n:'A-TO', name:'Timothy Olyphant', artist:'Cobb Vanth'},
      {n:'A-TW', name:'Taika Waititi', artist:'IG-11'},
      {n:'A-WH', name:'Werner Herzog', artist:'The Client'},
    ]
  },
];

export const ALL_CARD_KEYS = SETS.flatMap(set =>
  set.cards.map(card => `${set.id}__${card.n}`)
);

export const PARALLELS = BASE_PARALLELS;
export const AUTO_PARALLELS = AUTO_PARALLELS_LADDER;
export const INSERT_PARALLELS = INSERT_5;
